/**
 * Contains web service calls to execute a DocFinity Datasource
 */
export default {

    /**
     * Execute a DF DS and return its result.
     *
     * @param callback The function that should be called when the task is completed
     * @param datasourceId The ID of the DF DS to be executed
     * @param args The arguments to be passed along as input to the DF DS
     */
    executeDocfinityDatasource: function(callback, datasourceId, args) {
        return $.ajax({
            url: context.path + "/webservices/rest/document/datasource/" + datasourceId + "/execute/",
            type: "POST",
            data: JSON.stringify(args),
            contentType: "application/json",
            dataType: "json",
            success: callback
        });
    }

};
